module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeAgMAAAA0kSSHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTC0tLS0tLS4uLoEoc6wAAAADdFJOUwCW+oAF8kAAAAAdSURBVBjTY8j/DwEXGKCM/w8YEGL0BQPvFrwuAADuNUvZhx5ShAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHeader/menu.png
// module id = e1Aq
// module chunks = 0